import React, { ReactElement } from 'react'
// Externals imports.
import { MobileStepper } from '@material-ui/core'
// Sub imports.
import { IndicatorVariant } from './Constants'
// CSS imports. Commented out because of current build process.
// import './progressIndicator.scss';

/**
 * Component properties type.
 */
type Props = {
    length: number
    activeIndex: number
    variant: IndicatorVariant
}

/**
 * Progress indicator component.
 *
 * @param length Number of steps.
 * @param activeIndex Current step index.
 * @param variant Variant of the stepper.
 */
const ProgressIndicator: React.FC<Props> = ({ length, activeIndex, variant }: Props): ReactElement => {
    const stepIndicatorClass = `step-indicator ${variant !== IndicatorVariant.PROGRESS ? 'flex' : ''}`

    return (
        <div className={stepIndicatorClass}>
            <MobileStepper
                variant={variant}
                steps={length}
                activeStep={activeIndex}
                backButton={undefined}
                nextButton={undefined}
            />
        </div>
    )
}

export default ProgressIndicator
